export default __webpack_public_path__ + "static/media/hightlight4.14824b9a.png";